import React from "react";
import { Footer, Header } from "../Components";
import { useTranslation } from "react-i18next";
import AboutUsBanner from "../Components/AboutUsBanner ";
import FooterTopBar from "../Components/FooterTopBar";
export const Aboutus = () => {
  document.title = "About Us - Famra Cure";
  const { t } = useTranslation();
  return (
    <>
    {/* <TopBar/>  */}

    {/* <DoctorBlog></DoctorBlog> */}
      <Header />
     <AboutUsBanner/>
      <div className="px-6 md:px-12">
        <div className="mx-auto sm:max-w-2xl md:max-w-3xl lg:max-w-5xl xl:max-w-7xl xl:px-32">
          <h1 className="text-3xl font-semibold text-left mt-10 text-sky-800">
            {t("About.aboutUsTitle")}
          </h1>
        </div>
      </div>
      
      {/* Section 1: Who We Are - Image on Right */}
      <div className="px-6 py-8 text-left md:px-12">
        <div className="w-100 mx-auto sm:max-w-2xl md:max-w-3xl lg:max-w-5xl xl:max-w-7xl xl:px-32">
          <div className="grid items-center gap-8 lg:grid-cols-2">
            <div className="mb-12 md:mt-12 lg:mt-0 lg:mb-0">
              <div className="block rounded-lg bg-[hsla(0,0%,100%,0.55)] px-6 py-12 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-[hsla(0,0%,5%,0.55)] dark:shadow-black/20 md:px-12 lg:-mr-14 backdrop-blur-[30px]">
                <h2 className="text-2xl font-bold mb-6 text-sky-800">Who We Are</h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  We are a global online health leader, bridging the gap between patients and medical experts. We simplify the second consultation process, delivering personalized, relevant, and convenient healthcare advice from top-tier specialists directly to your screen.
                </p>
              </div>
            </div>
            <div className="md:mb-12 lg:mb-0">
              <img
                src="/img/Doctors2.jpg"
                className="w-full rounded-lg shadow-lg dark:shadow-black/20"
                alt="Medical professionals"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Section 2: Expert Opinions - Image on Left */}
      <div className="px-6 py-8 text-left md:px-12">
        <div className="w-100 mx-auto sm:max-w-2xl md:max-w-3xl lg:max-w-5xl xl:max-w-7xl xl:px-32">
          <div className="grid items-center gap-8 lg:grid-cols-2">
            <div className="md:mb-12 lg:mb-0 order-2 lg:order-1">
              <img
                src="/img/about-us-2.jpg"
                className="w-full rounded-lg shadow-lg dark:shadow-black/20"
                alt="Expert medical consultation"
              />
            </div>
            <div className="mb-12 md:mt-12 lg:mt-0 lg:mb-0 order-1 lg:order-2">
              <div className="block rounded-lg bg-[hsla(0,0%,100%,0.55)] px-6 py-12 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-[hsla(0,0%,5%,0.55)] dark:shadow-black/20 md:px-12 lg:-ml-14 backdrop-blur-[30px]">
                <h2 className="text-2xl font-bold mb-6 text-sky-800">Expert Second Medical Opinions at Your Fingertips</h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  Whether you're seeking a second opinion or a complex surgical intervention, Famra Cure connects you with experienced specialists and innovative treatments. We offer unbiased, patient-centered advice—completely free from conflicts of interest. Best of all, our process is entirely remote, allowing you to access world-class expertise without leaving your home.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3: Importance of Second Opinion - Image on Right */}
      <div className="px-6 py-8 text-left md:px-12">
        <div className="w-100 mx-auto sm:max-w-2xl md:max-w-3xl lg:max-w-5xl xl:max-w-7xl xl:px-32">
          <div className="grid items-center gap-8 lg:grid-cols-2">
            <div className="mb-12 md:mt-12 lg:mt-0 lg:mb-0">
              <div className="block rounded-lg bg-[hsla(0,0%,100%,0.55)] px-6 py-12 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-[hsla(0,0%,5%,0.55)] dark:shadow-black/20 md:px-12 lg:-mr-14 backdrop-blur-[30px]">
                <h2 className="text-2xl font-bold mb-6 text-sky-800">The Importance of a Second Opinion</h2>
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  A serious diagnosis can be life-changing. Validating your results with an independent clinical expert ensures accuracy before moving forward. Our consultants provide clear, detailed explanations of your condition and help you understand how your treatment plan will impact your personal, professional, and medical future.
                </p>
              </div>
            </div>
            <div className="md:mb-12 lg:mb-0">
              <img
                src="/img/about-us-3.jpg"
                className="w-full rounded-lg shadow-lg dark:shadow-black/20"
                alt="Medical second opinion"
              />
            </div>
          </div>
        </div>
      </div>

      <FooterTopBar/>
      <Footer />
    </>
  );
};

export default Aboutus;
